<button
  mat-button
  class="basket-btn"
  (click)="openBasket()"
  [disabled]="site.isCheckoutPage()"
  aria-label="Åbn kurv"
>
  <mat-icon aria-hidden="true">shopping_cart</mat-icon>
  <span class="basket-btn__label">
    Kurv
    @if (basket.itemsCount() > 0) {
      <span class="basket-btn__badge" aria-hidden="true">{{ basket.itemsCount() }}</span>
    }
  </span>
</button>
